// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aee11584","885":"6e876a69","977":"afb7bd73"}[chunkId] + ".chunk.js";
};